








import Vue from "vue";
import { Component } from "vue-property-decorator";
import ApiFactory from "../../api/ApiFactory";
import { ExpenseTypeDto } from "@/api/ClientPortalApiClient";
@Component({})
export default class CbxExpenseType extends Vue {
  private types: ExpenseTypeDto[] | null = [];
  public selectedType = new ExpenseTypeDto();

  public created() {
    this.getAvailableTypes();
  }

  public setSelected(type: ExpenseTypeDto | undefined) {
    if (type) {
      this.selectedType = type;
    }
  }

  public typeSelected(type: ExpenseTypeDto) {
    this.$emit("expenseTypeSelected", type);
  }

  private getAvailableTypes() {
    const api = ApiFactory.CreateDataClient();
    api
      .expenseType_IndexAll()
      .then(result => {
        if (result) {
          this.types = result;
        } else {
          this.types = [];
        }
      })
      .catch(error => {
        console.log(error);
        this.types = [];
      });
  }
}
